var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3SuspensionLampOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 55.75h4v6h-4v-6zM46.14 52l4.24 4.24 2.83-2.83L49 49.13 46.14 52zm-23.23 1.37l2.83 2.83L30 52l-2.83-2.83-4.26 4.2zM69 7v62H7V7h62zm-4 4H40v16.9c7.89.88 14 6.85 14 14.1h-8.73a7.33 7.33 0 11-14.42 0H22c0-7.25 6.11-13.22 14-14.1V11H11v54h54V11zM35 42a3.33 3.33 0 106.12 0H35z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Suspension_lamp_on.d3073b73.svg";
export { SvgA3SuspensionLampOn as ReactComponent };